import 'css-chunksrc/client/common/elementAttachments/dropZone/styles.scss';export default {};